const DURATION = 2000; // in milliseconds
const sections = document.querySelectorAll('section.numbers');

sections.forEach((section) => {
	const numbers = section.querySelectorAll('[data-number]');

	let hasAnimated = false;

	function animateNumbers() {
		if (hasAnimated) return; // Prevent running twice
		hasAnimated = true;

		numbers.forEach((el) => {
			const target = parseInt(el.dataset.number, 10);

			if (Number.isNaN(target)) {
				return;
			}

			if (target === 0) {
				el.textContent = '0';
				return;
			}

			function easeInOutCubic(t) {
				return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
			}

			let start = null;
			const step = (timestamp) => {
				if (start === null) {
					start = timestamp;
				}
				const progress = Math.min((timestamp - start) / DURATION, 1);
				const eased = easeInOutCubic(progress);
				el.textContent = String(Math.floor(eased * target));
				if (progress < 1) {
					requestAnimationFrame(step);
				} else {
					el.textContent = String(target);
				}
			};

			requestAnimationFrame(step);
		});
	}

	const observer = new window.IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					animateNumbers();
					obs.unobserve(section);
				}
			});
		},
		{
			threshold: 0.8,
		}
	);

	observer.observe(section);
});
